import React from 'react'
import env from './../../../../environments/environment'
import './FindAnAgent.component.scss'

const FindAnAgent = () => {
  return (
    <section className='find-an-agent-section'>
      <div className='find-an-agent-section__inner'>
        <div className='find-an-agent-section__left-col'>
          <img
            src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fwebsite%2Fimg.find-an-agent.jpeg?alt=media`}
            alt='Woman with long dark hair smiles, wearing a blue shirt, against a white background.'
          />
        </div>
        <div className='find-an-agent-section__right-col'>
          <h2 className='find-an-agent-section__heading'>
            <span>Connect With a Licensed Agent in Your Area</span>
          </h2>
          <div className='find-an-agent-section__body'>
            <p>
              <span>
                Our nationwide network of licensed USA Benefits Group agents are here to provide personalized benefits
                guidance based on your unique needs.
              </span>
            </p>
            <p>
              <span>
                Whether you prefer an in-person consultation, virtual meeting, or phone call — we'll connect you with a
                trusted advisor in your area.
              </span>
            </p>
          </div>
          <a
            className='find-an-agent-section__cta-btn'
            href='/our-licensed-agents'
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='find-an-agent-section__cta-icon icon-star' aria-hidden='true'></span>
            <span className='find-an-agent-section__cta-text'>Find An Agent</span>
          </a>
        </div>
      </div>
    </section>
  )
}

export default FindAnAgent
